import React from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

const DetailsData = ({
  validez,
  cobro,
  entrega,
  garantia,
  referencia,
  total,
  onFieldChange
}) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 2, color: "#1565C0" }}>
        Detalles
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            label="Validez de la Oferta"
            value={validez}
            onChange={(e) => onFieldChange("validez", e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Forma de Pago"
            value={cobro}
            onChange={(e) => onFieldChange("cobro", e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Entrega"
            value={entrega}
            onChange={(e) => onFieldChange("entrega", e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            label="Garantía"
            value={garantia}
            onChange={(e) => onFieldChange("garantia", e.target.value)}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Referencia"
            value={referencia}
            onChange={(e) => onFieldChange("referencia", e.target.value)}
            placeholder="Ingrese referencia de proforma"
            fullWidth
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            label="Total Proforma"
            value={`$${!isNaN(total) ? parseFloat(total).toFixed(2) : "0.00"}`}
            fullWidth
            InputProps={{ readOnly: true }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsData;
